import { useEffect } from 'react';

import { useScrollContext } from 'state/scroll';

/**
 * Reset targeted scroll element to the top when the hook is mounted.
 * The target scroll element is set on the ScrollContext
 */
export const useScrollResetOnMount = () => {
  const { scrollTo } = useScrollContext();

  useEffect(() => {
    scrollTo({ animated: false });
  }, [scrollTo]);
};
